// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"two-arrows-radio_buttonWrapper_1PXOH","slot":"two-arrows-radio_slot_1q0xT","button":"two-arrows-radio_button_VgiqP","active":"two-arrows-radio_active_-hlG-"};